<script>
import NavBar from "@/components/nav-bar"
import RightBar from "@/components/right-bar"
import Footer from "@/components/footer"

export default {
  computed: {
    isAdmin: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "admin" &&
          this.$store.getters.isAdmin
          ? true
          : false
      },
    },

    isOperator: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "operator" &&
          this.$store.getters.isOperator
          ? true
          : false
      },
    },

    isSeller: {
      get() {
        return this.$store &&
          this.$store.state.user.data.ur == "seller" &&
          this.$store.getters.isSeller
          ? true
          : false
      },
    },
  },

  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onRoutechange(ele) {
      this.initActiveMenu(ele.path)
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#navbar-nav")) {
          let a = document
            .querySelector("#navbar-nav")
            .querySelector('[href="' + ele + '"]')

          if (a) {
            a.classList.add("active")
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown")
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show")
              parentCollapseDiv.parentElement.children[0].classList.add(
                "active"
              )
              parentCollapseDiv.parentElement.children[0].setAttribute(
                "aria-expanded",
                "true"
              )
              if (
                parentCollapseDiv.parentElement.closest(
                  ".collapse.menu-dropdown"
                )
              ) {
                parentCollapseDiv.parentElement
                  .closest(".collapse")
                  .classList.add("show")
                if (
                  parentCollapseDiv.parentElement.closest(".collapse")
                    .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .previousElementSibling.classList.add("active")
              }
            }
          }
        }
      }, 1000)
    },
  },
  components: {
    NavBar,
    RightBar,
    Footer,
  },
}
</script>

<template>
  <div>
    <div id="layout-wrapper">
      <NavBar />
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- Dark Logo-->
          <router-link :to="{ name: 'dashboard' }" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt="" height="17" />
            </span>
          </router-link>
          <!-- Light Logo-->
          <router-link :to="{ name: 'dashboard' }" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt="" height="17" />
            </span>
          </router-link>
          <button
            type="button"
            class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i class="ri-record-circle-line"></i>
          </button>
        </div>
        <div id="scrollbar">
          <b-container fluid>
            <ul class="navbar-nav h-100" id="navbar-nav">
              <li class="nav-item">
                <router-link
                v-if="isAdmin || isOperator"
                  class="nav-link menu-link"
                  :to="{ name: 'dashboard' }"
                >
                  <i class="mdi mdi-speedometer"></i>
                  <span data-key="t-dashboard">{{ $t("t-dashboard") }}</span>
                </router-link>

                <router-link
                v-else-if="isSeller"
                  class="nav-link menu-link"
                  :to="{ name: 'store.dashboard' }"
                >
                  <i class="mdi mdi-speedometer"></i>
                  <span data-key="t-dashboard">{{ $t("t-dashboard") }}</span>
                </router-link>
              </li>
              <!-- end Dashboard -->

              <li class="nav-item" v-if="isAdmin">
                <router-link
                  class="nav-link menu-link"
                  :to="{ name: 'operators' }"
                >
                  <i class="mdi mdi-account-supervisor-outline"></i>
                  <span data-key="t-operator">{{ $t("t-operator") }}</span>
                </router-link>
              </li>
              <!-- end Operator -->

              <li class="nav-item">
                <b-link
                  class="nav-link menu-link"
                  href="#sidebarProducts"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarProducts"
                >
                  <i class="mdi mdi-cube-outline"></i>
                  <span data-key="t-products"> {{ $t("t-products") }}</span>
                </b-link>
                <div class="collapse menu-dropdown" id="sidebarProducts">
                  <ul class="nav nav-sm flex-column">
                    <li class="nav-item" v-if="isAdmin || isOperator">
                      <router-link
                        :to="{ name: 'product.categories' }"
                        class="nav-link"
                        data-key="t-product-categories"
                      >
                        {{ $t("t-product-categories") }}
                      </router-link>
                    </li>

                    <li class="nav-item" v-if="isAdmin || isOperator">
                      <router-link
                        :to="{ name: 'product.attributes' }"
                        class="nav-link"
                        data-key="t-product-attributes"
                      >
                        {{ $t("t-product-attributes") }}
                      </router-link>
                    </li>

                    <li class="nav-item" v-if="isAdmin || isOperator">
                      <router-link
                        :to="{ name: 'attribute.values' }"
                        class="nav-link"
                        data-key="t-attribute-values"
                      >
                        {{ $t("t-attribute-values") }}
                      </router-link>
                    </li>

                    <li class="nav-item" v-if="isAdmin || isOperator">
                      <router-link
                        :to="{ name: 'tags' }"
                        class="nav-link"
                        data-key="t-tags"
                      >
                        {{ $t("t-tags") }}
                      </router-link>
                    </li>

                    <li class="nav-item">
                      <router-link
                        v-if="isAdmin || isOperator"
                        :to="{ name: 'product.products' }"
                        class="nav-link"
                        data-key="t-products"
                      >
                        {{ $t("t-products") }}
                      </router-link>

                      <router-link
                        v-else-if="isSeller"
                        :to="{ name: 'store.product.products' }"
                        class="nav-link"
                        data-key="t-products"
                      >
                        {{ $t("t-products") }}
                      </router-link>
                    </li>

                    <li class="nav-item" v-if="isAdmin || isOperator">
                      <router-link
                        :to="{ name: 'faqs' }"
                        class="nav-link"
                        data-key="t-faqs"
                      >
                        {{ $t("t-faqs") }}
                      </router-link>
                    </li>

                    <li class="nav-item" v-if="isAdmin || isOperator">
                      <router-link
                        :to="{ name: 'comments' }"
                        class="nav-link"
                        data-key="t-comments"
                      >
                        {{ $t("t-comments") }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <!-- end Product Menu -->

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link class="nav-link menu-link" :to="{ name: 'users' }">
                  <i class="mdi mdi-account-group-outline"></i>
                  <span data-key="t-users">{{ $t("t-users") }}</span>
                </router-link>
              </li>
              <!-- end Users -->

              <li class="nav-item" v-if="isAdmin || isOperator">
                <b-link
                  class="nav-link menu-link"
                  href="#sliderbanner"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sliderbanner"
                >
                  <i class="mdi mdi-image-multiple-outline"></i>
                  <span data-key="t-sliderbanner">
                    {{ $t("t-sliderbanner") }}</span
                  >
                </b-link>
                <div class="collapse menu-dropdown" id="sliderbanner">
                  <ul class="nav nav-sm flex-column">
                    <li class="nav-item">
                      <router-link
                        :to="{ name: 'sliders' }"
                        class="nav-link"
                        data-key="t-slider"
                      >
                        {{ $t("t-slider") }}
                      </router-link>
                    </li>
                    <li class="nav-item">
                      <router-link
                        :to="{ name: 'ads' }"
                        class="nav-link"
                        data-key="t-ads-banners"
                      >
                        {{ $t("t-ads-banners") }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>

              <!-- end sliders and banners -->

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  class="nav-link menu-link"
                  :to="{ name: 'stores' }"
                >
                  <i class="mdi mdi-storefront-outline"></i>
                  <span data-key="t-stores">{{ $t("t-stores") }}</span>
                </router-link>
              </li>
              <!-- end stores -->

              <li class="nav-item" v-if="isAdmin">
                <router-link
                  class="nav-link menu-link"
                  :to="{ name: 'settings' }"
                >
                  <i class="mdi mdi-cog-outline"></i>
                  <span data-key="t-settings">{{ $t("t-settings") }}</span>
                </router-link>
              </li>
              <!-- end settings -->

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  class="nav-link menu-link"
                  :to="{ name: 'orders' }"
                >
                  <i class="mdi mdi-shopping-outline"></i>
                  <span data-key="t-orders">{{ $t("t-orders") }}</span>
                </router-link>
              </li>

              <li class="nav-item" v-else-if="isSeller">
                <router-link
                  class="nav-link menu-link"
                  :to="{ name: 'store.orders' }"
                >
                  <i class="mdi mdi-shopping-outline"></i>
                  <span data-key="t-orders">{{ $t("t-orders") }}</span>
                </router-link>
              </li>
              <!-- end orders -->

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  class="nav-link menu-link"
                  :to="{ name: 'messages' }"
                >
                  <i class="mdi mdi-message-text-outline"></i>
                  <span data-key="t-messages">{{ $t("t-messages") }}</span>
                </router-link>
              </li>
              <!-- end messages -->

              <li class="nav-item" v-if="isAdmin || isOperator">
                <router-link
                  class="nav-link menu-link"
                  :to="{ name: 'cooperation.requests' }"
                >
                  <i class="mdi mdi-handshake-outline"></i>
                  <span data-key="t-cooperation-requests">{{
                    $t("t-cooperation-requests")
                  }}</span>
                </router-link>
              </li>
              <!-- end cooperation requests -->

              <li class="nav-item">
                <b-link
                  class="nav-link menu-link"
                  href="#financial"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="financial"
                >
                  <i class="mdi mdi-cash-multiple"></i>
                  <span data-key="t-financial"> {{ $t("t-financial") }}</span>
                </b-link>
                <div class="collapse menu-dropdown" id="financial">
                  <ul class="nav nav-sm flex-column">
                    <li class="nav-item" v-if="isAdmin">
                      <router-link
                        :to="{ name: 'financial.transactions' }"
                        class="nav-link"
                        data-key="t-transactions"
                      >
                        {{ $t("t-transactions") }}
                      </router-link>
                    </li>

                    <li class="nav-item" v-if="isSeller">
                      <router-link
                        :to="{ name: 'store.products.unsettled' }"
                        class="nav-link"
                        data-key="t-unsettled-products"
                      >
                        {{ $t("t-unsettled-products") }}
                      </router-link>
                    </li>

                    <li class="nav-item" v-if="isSeller">
                      <router-link
                        :to="{ name: 'store.settlement.payments' }"
                        class="nav-link"
                        data-key="t-settlement-payments"
                      >
                        {{ $t("t-settlement-payments") }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <!-- end financial Menu -->

              <li class="nav-item" v-if="isAdmin || isOperator">
                <b-link
                  class="nav-link menu-link"
                  href="#reminders"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="reminders"
                >
                  <i class="mdi mdi-bell-ring-outline"></i>
                  <span data-key="t-reminders"> {{ $t("t-reminders") }}</span>
                </b-link>
                <div class="collapse menu-dropdown" id="reminders">
                  <ul class="nav nav-sm flex-column">
                    <li class="nav-item">
                      <router-link
                        :to="{ name: 'occasion.occasions' }"
                        class="nav-link"
                        data-key="t-occasions"
                      >
                        {{ $t("t-occasions") }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <!-- end financial Menu -->
            </ul>
          </b-container>
          <!-- Sidebar -->
        </div>
        <!-- Left Sidebar End -->
        <!-- Vertical Overlay-->
        <div class="vertical-overlay"></div>
      </div>
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <b-container fluid>
            <slot />
          </b-container>
        </div>
        <Footer />
      </div>
      <RightBar />
    </div>
  </div>
</template>
